import { ApiRequestOptions } from '@api/core/ApiRequestOptions';
import { getRequestOptions } from '@api/core/utils';

import type { ContractConfirmViewModel } from '../models/ContractConfirmViewModel';
import type { ContractViewModel } from '../models/ContractViewModel';
import type { EmptyResponseViewModel } from '../models/EmptyResponseViewModel';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class ContractsService {
  /**
   * Url
   * Gets the contracts
   * @returns ContractViewModel Success
   * @throws ApiError
   */
  public static async contractsUrl(
    {
      basketId,
    }: {
      /**
       * Basket Id
       */
      basketId: string;
    },
    options?: Partial<ApiRequestOptions>
  ): CancelablePromise<Array<ContractViewModel>> {
    const { cookies = {}, headers = {} } = options ?? {};
    delete cookies.token;
    const result = await __request<Array<ContractViewModel>>({
      method: 'GET',
      url: `/contracts`,
      headers: {
        ...(basketId ? { basketId: basketId } : {}),
        ...getRequestOptions(headers, 'headers'),
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Server Error`,
      },
      cookies: { ...getRequestOptions(cookies, 'cookies') },
    });
    return result;
  }

  /**
   * Confirm
   * Confirms the contracts
   * @returns EmptyResponseViewModel Success
   * @throws ApiError
   */
  public static async contractsConfirm(
    {
      basketId,
      body,
    }: {
      /**
       * Basket Id
       */
      basketId: string;
      body?: Array<ContractConfirmViewModel>;
    },
    options?: Partial<ApiRequestOptions>
  ): CancelablePromise<EmptyResponseViewModel> {
    const { cookies = {}, headers = {} } = options ?? {};
    delete cookies.token;
    const result = await __request<EmptyResponseViewModel>({
      method: 'POST',
      url: `/contracts`,
      headers: {
        ...(basketId ? { basketId: basketId } : {}),
        ...getRequestOptions(headers, 'headers'),
      },
      body: body,
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Server Error`,
      },
      cookies: { ...getRequestOptions(cookies, 'cookies') },
    });
    return result;
  }
}
